import * as React from "react";
import Loader from "../Common/Loader";
import { fetchTransactions } from "../../actions/transactionAction";
import {
  TRANSACTION_TABLE_HEADER,
  EXTRATRANSACTION_TABLE_HEADER,
  TRANSACTION_FILTER,
  TRANSACTION_NOT_FOUND,
  TRANSACTION_DEFAULT_FILTER_VALUE,
} from "../../util/constants/types";
import SCCustomerTransactionsTable, {
  SCCustomerTransaction,
  SCCustomerFilterTransaction
} from "./css";
import { useDispatch, useSelector } from "react-redux";
import { transactionMainRowTransformer } from "./TransactionMainRow";
import { TransactionSubRowTransformer } from "./TransactionSubRow";
import { loadPageData } from "../../actions";
import * as CONSTANTS from "../../util/constants/messages";

import {
  Button,
  Dropdown,
  IconExport
} from "@payright/web-components";
import Footer from "../Footer";
import ExportCSV from "./ExportCSV";
import "@progress/kendo-react-data-tools";
import "@progress/kendo-react-buttons";
import "@progress/kendo-react-dropdowns";
import "@progress/kendo-react-inputs";
import "@progress/kendo-react-dateinputs";
import "@progress/kendo-react-animation";
import "@progress/kendo-react-popup";
import "@progress/kendo-drawing";
import { NavWithComponent } from "../Nav";
import { RootState } from "../../reducers";
import TableWithPagination from "../TableWithPagination/TableWithPagination";

export type Transaction = {
  transactionList: {
    ID: string;
    requestCreated: string;
    paymentPurpose: string;
    paymentReference: string;
    paymentStatus: string;
    paymentAmount: number;
  };
  transactionsParts: {
    ID: string;
    dateApplied: string;
    transactionReason: string;
    paymentPlanName: string;
    paidAmount: number;
  }[];
}

type TransactionsList= {
  customer: any;
  transactions: Transaction[];
  error: any;
  loading: any;
};

const TransactionsList: React.FC<{}> = () => {
  const dispatch = useDispatch();

  const exportCsvRef = React.useRef(null);
  const tableRef = React.useRef({
    getTableRows: () => [],
  });
  const { customer, error, loading, transactions } = useSelector<RootState, TransactionsList>(state => ({
    customer: state.pageData.customer,
    error: state.transactions.error,
    loading: state.transactions.loading,
    transactions: state.pageData.transactions ?? [],
  }));
  const [selectedFilter, setSelectedFilter] = React.useState("Last 30 days");
  const [exporting, setExporting] = React.useState(false);

  React.useEffect(() => {
    dispatch(fetchTransactions(TRANSACTION_DEFAULT_FILTER_VALUE));
  }, []);

  React.useEffect(() => {
    if (!customer) {
      dispatch(loadPageData());
    }
  }, [customer]);

  React.useEffect(() => {
    if(exporting) {
      exportCsvRef.current.export();
      setExporting(false);
    }
}, [exporting]);

  const handleDropDownSelect = (selectedValue) => {
    setSelectedFilter(selectedValue);
    dispatch(fetchTransactions(selectedValue));
  };

  const handleExport = () => {
    exportCsvRef.current.setData(tableRef.current.getTableRows());
    setExporting(true);
  };

  if (error != null) {
    return <div>Error! {error.message}</div>;
  }

  if (loading) {
    return <Loader text={CONSTANTS.LOADING_TEXT} />;
  }


  return (
    <>
      <NavWithComponent title="Transactions" activePage="/my-transactions"/>

      <SCCustomerFilterTransaction>
        <div>
          <ExportCSV
            ref={exportedCsvRef => {
              exportCsvRef.current = exportedCsvRef;
            }}
          />
        </div>

        <div className="containerTransaction">
          <div className="right-col">
            <div className="showingResult">
              <h5>Showing</h5>
            </div>
            <div>
              <h5>
                <Dropdown
                  className="customDropDown"
                  options={TRANSACTION_FILTER}
                  value={selectedFilter}
                  handleSelect={handleDropDownSelect}
                />
              </h5>
            </div>
            <div className="exportButton">
              <h5>
                <Button
                  colour="blue"
                  size="small"
                  outline
                  handleClick={handleExport}
                  icon={<IconExport />}
                  iconPosition="left"
                >
                  Export{" "}
                </Button>
              </h5>
            </div>
            <div></div>
          </div>
        </div>
      </SCCustomerFilterTransaction>
      <SCCustomerTransaction>
        {transactions.length > 0 ? (
            <TableWithPagination 
              initialSortField="requestCreated"
              tableHeaders={TRANSACTION_TABLE_HEADER}
              rawData={transactions}
              subTableHeaders={EXTRATRANSACTION_TABLE_HEADER}
              mainRowTransformer={transactionMainRowTransformer}
              subRowTransformer={TransactionSubRowTransformer}
              ref={tableRef}
              Table={SCCustomerTransactionsTable}
            />
        ) : (
            <div className="noRecords">{TRANSACTION_NOT_FOUND}</div>
        )}
      </SCCustomerTransaction>
      <Footer />
    </>
  );
}


export default TransactionsList;
